const pirateTroubles = [
    'Постоянные блокировки и изменения адреса сервера',
    'Проблемы со входом на сервер',
    'Требование в использовании старой версии клиента',
    'Отсутствие клиентской поддержки',
    'Внезапные перезагрузки'
]
export default pirateTroubles;